
import { useEffect, useState, useRef } from "react";
import { authenticationParameters, msalInstance } from "./AuthZ";
import { useDispatch, useStore } from "react-redux";
import { setUserInfo } from "../../redux/slice/headerSlice";
import { sessionCreate } from "../../utils/session";
//2026
// export async function fetchWithAuth(url: string, options: RequestInit = {}) {
//   const accounts = msalInstance.getAllAccounts();
//   if (accounts.length === 0) {
//     throw new Error("User not authenticated");
//   }

//   try {
//     const tokenResponse = await msalInstance.acquireTokenSilent({
//       scopes: authenticationParameters.scopes,
//       account: accounts[0],
//     });

//     return fetch(url, {
//       ...options,
//       headers: {
//         ...(options.headers || {}),
//         Authorization: `Bearer ${tokenResponse.accessToken}`,
//       },
//     });
//   } catch (err) {
//     globalThis.dispatchEvent(new Event("auth:expired"));
//     throw err;
//   }
// }
export async function fetchWithAuth(url: string, options: RequestInit = {}) {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) {
    throw new Error("User not authenticated");
  }
 
  try {
    const tokenResponse = await msalInstance.acquireTokenSilent({
      scopes: authenticationParameters.scopes,
      account: accounts[0],
    });
 
    return fetch(url, {
      ...options,
      headers: {
        ...(options.headers || {}),
        Authorization: `Bearer ${tokenResponse.accessToken}`,
      },
    });
  } catch (err) {
    if (url.includes("logout")) {
      try {
        const tokenResponse = await msalInstance.acquireTokenPopup({
          scopes: authenticationParameters.scopes,
        });
 
        return fetch(url, {
          ...options,
          headers: {
            ...(options.headers || {}),
            Authorization: `Bearer ${tokenResponse.accessToken}`,
          },
        });
      } catch (popupErr) {
        globalThis.dispatchEvent(new Event("auth:expired"));
        throw popupErr;
      }
    }
 
    globalThis.dispatchEvent(new Event("auth:expired"));
    throw err;
  }
}
 
async function handleLogin(instance: any) {
  await instance.initialize().catch(() => {});
  const tokenResponse = await instance.handleRedirectPromise().catch(() => {});

  if (!tokenResponse) {
    const accounts = instance.getAllAccounts();
    if (accounts.length === 0) {
      await instance.loginRedirect(authenticationParameters);
      return { isAuthenticated: false, account: null };
    }
    return { isAuthenticated: true, account: accounts[0] };
  }

  return { isAuthenticated: true, account: tokenResponse.account };
}

export const AuthenticateUser = (props: any) => {
  const hasRun = useRef(false);
  const [userAuthenticated, setUserAuthenticated] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const dispatch = useDispatch();
  const store = useStore();

  if (window.location.pathname === "/sessionexpired") {
    return <>{props.children}</>;
  }

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    handleLogin(msalInstance).then(async ({ isAuthenticated, account }) => {
      setIsAuthenticated(isAuthenticated);

      if (account) {
        msalInstance.setActiveAccount(account);

        dispatch(
          setUserInfo({
            EmailID: account.username || "",
            WWID: String(account.idTokenClaims?.employeeId || ""),
          })
        );

        await sessionCreate(dispatch, store.getState);
      }

      setUserAuthenticated(true);
    });
  }, [dispatch, store]);

  return <>{isAuthenticated && userAuthenticated ? props.children : ""}</>;
};
